// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1RGSA","buttons":"PendingPaymentAlert_buttons___U0Id"};